import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"

const People = () => {
    useEffect(() =>{
        document.title = "Our People | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="peoplefirstbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Our People</h3>
        <p className='description hmfirstboxdescription'>
        Rich-Oak invests in building businesses that can produce long-term competitive advantage which yields competitive returns, improve lives and economic growth for our investors, customers and other stakeholders.

        </p>
        
       
  
        </div>
    </div>
    </Row>
    </div>

    <div className='hmsecondbox'>
 
    </div>

    <div className='hmthirdbox'>
    <div className=''>
        {/* <Container> */}
            <Row>
                <div className='col-md-6 hideipad'>
                <img style={{width:"100%"}} src="images/culture.jpg"/> 
                {/* <iframe className="img-fluid" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
                    </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-lg-6 col-md-12'>
                    <h1 className="hmwwd"><span style={{color:"#D80032"}}> Our </span> Culture</h1>
                    {/* <hr class="hpwwdhr1"/> */}
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, 
                        innovation and providing premium value. Our vision is to be Africa's most reliable financial partner. 
                        We invest capital on behalf of individuals and institutions across the alternative asset classes in real estate, 
                        credit and agriculture, increasing the wealth of our investors.
                         Our businesses are impact driven, providing support to various industries and sectors.</p>
                    </div>

                    {/* <div className='col-md-5 formobileonly'>
                <iframe className="img-fluid hmytvideo" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> */}

               
                
            </Row>
        {/* </Container> */}
        </div>
    </div>

{/* <div className="container">
<div className="testimonialbox">
    <div class="row">
    <div className="col-lg-4 col-md-12 col-sm-12 testimonialbox1">
                    <img src="/images/hyphen.svg" alt="" />
                    <p className="testimonialbody">I am not just working for the organization, I am working for what I believe in and every growth achieved is about all of us.</p>
                    <div class="row">
                        <div className="col-lg-2 col-md-2">
                        <p className="centermobile">
                        <img width="64" height="64" style={{borderRadius:"16px"}} src="/images/staff/blessing.jpg"/>
                        </p>

                        </div>
                        <div className="col-lg-10 col-md-1">
                        <p className="testimonialname centermobile">Blessing<span style={{color:"#D80032"}}> Okekwue </span> </p>
                        <p  className="testimonialtitle centermobile">Team Lead HR/Legal.</p>
                        </div>
                    </div>
        </div>

        <div className="col-lg-4 col-md-12 col-sm-12 testimonialbox2">
                    <img src="/images/hyphen.svg" alt="" />
                    <p className="testimonialbody">I am not just working for the organization, I am working for what I believe in and every growth achieved is about all of us.</p>
                    <div class="row">
                        <div className="col-lg-2 col-md-2">
                        <p className="centermobile">
                        <img width="64" height="64" style={{borderRadius:"16px"}} src="/images/staff/blessing.jpg"/>
                        </p>
                        </div>
                        <div className="col-lg-10 col-md-3">
                        <p className="testimonialname centermobile">Blessing<span style={{color:"#D80032"}}> Okekwue </span> </p>
                        <p  className="testimonialtitle centermobile">Team Lead HR/Legal.</p>
                        </div>
                    </div>
        </div>

        <div className="col-lg-4 col-md-12 col-sm-12 testimonialbox3">
                    <img src="/images/hyphen.svg" alt="" />
                    <p className="testimonialbody">I am not just working for the organization, I am working for what I believe in and every growth achieved is about all of us.</p>
                    <div class="row">
                    <div className="col-lg-2 col-md-2">
                    <p className="centermobile">
                        <img width="64" height="64" style={{borderRadius:"16px"}} src="/images/staff/blessing.jpg"/>
                        </p>
                        </div>
                        <div className="col-lg-10 col-md-3">
                        <p className="testimonialname centermobile">Blessing<span style={{color:"#D80032"}}> Okekwue </span> </p>
                        <p  className="testimonialtitle centermobile">Team Lead HR/Legal.</p>
                        </div>
                    </div>
        </div>
    </div>

</div>
</div> */}


    <div className='hmtenthbox'>
        <Row>
            <div className='col-md-12'>
            <p className="whatwedohead">Meet the <span style={{color:"#D80032"}}>Team</span> </p>
           <hr class="whatwedohr"/>
            <p className="whatwedobody">We invest on behalf of private individuals and institutions across different alternative <br/>investment asset classes in order to achieve thier investment goals</p>
            </div>
        </Row>
      
    </div>

    <div className='hmlastbox' >
  
        <Row>

     
                        <div className='col-md-2'>
            

            <div className="">
            <p class="centermobile">  <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/chiamaka.jpg"/> </p>
                        <p className="whatwedolastboxhead3 centermobile">Chiamaka<span style={{color:"#D80032"}}> Ohia </span> </p>
                        <p  className="whatwedolastboxbody centermobile">Account</p>
                        {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
            
                        </div>
                        </div>

                        <div class="col-md-1"></div>
        
                        <div className='col-md-2'>
    

    <div className="">
    <p class="centermobile">   <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/ugo.jpg"/> </p>
                <p className="whatwedolastboxhead3 centermobile">Ugonnam<span style={{color:"#D80032"}}> Ohakah </span> </p>
                <p  className="whatwedolastboxbody centermobile">Investment Officer</p>
                {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
    
                </div>
                </div>
                <div class="col-md-1"></div>

<div className='col-md-2'>


<div className="">
<p class="centermobile"> <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/Daniel.jpg"/> </p>
            <p className="whatwedolastboxhead3 centermobile">Daniel<span style={{color:"#D80032"}}> Oluebube </span> </p>
            <p  className="whatwedolastboxbody centermobile">Investment Officer</p>
            {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}

            </div>
            </div>

            <div class="col-md-1"></div>

<div className='col-md-2'>


<div className="">
<p class="centermobile"> <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/Abel.jpg"/> </p>
            <p className="whatwedolastboxhead3 centermobile">Abel<span style={{color:"#D80032"}}> Abalaka </span> </p>
            <p  className="whatwedolastboxbody centermobile">Investment Officer</p>
            {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}

            </div>
            </div>

    <div class="col-md-1"></div>

    <div className='col-md-2' style={{marginTop:"20px"}}>
    

    <div className="">
    <p class="centermobile"> <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/peejay.jpg"/> </p>
                <p className="whatwedolastboxhead3 centermobile">Pwadumbow<span style={{color:"#D80032"}}> Jaule </span> </p>
                <p  className="whatwedolastboxbody centermobile">Graphics/Videographer</p>
                {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
    
                </div>
                </div>

                <div class="col-md-1"></div>

                <div className='col-md-2' style={{marginTop:"20px"}}>
    

    <div className="">
    <p class="centermobile"> <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/isaac.jpg"/> </p>
                <p className="whatwedolastboxhead3 centermobile">Isaac<span style={{color:"#D80032"}}> Umoru </span> </p>
                <p  className="whatwedolastboxbody centermobile">Chief Architect, Earth VII</p>
                {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}
    
                </div>
                </div>
                <div class="col-md-1"></div>

                <div className='col-md-2' style={{marginTop:"20px"}}>


<div className="">
<p class="centermobile"> <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/joseph.jpg"/> </p>
            <p className="whatwedolastboxhead3 centermobile">Joseph<span style={{color:"#D80032"}}> Awyetu </span> </p>
            <p  className="whatwedolastboxbody centermobile">Quantity Surveyor</p>
            {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}

            </div>
            </div>
            <div class="col-md-1"></div>

<div className='col-md-2' style={{marginTop:"20px"}}>


<div className="">
<p class="centermobile"> <img class="img-fluid staffimagemobile"  style={{borderRadius:"15px"}}  src="images/staff/victor.jpg"/> </p>
            <p className="whatwedolastboxhead3 centermobile">Victor<span style={{color:"#D80032"}}> Ndak </span> </p>
            <p  className="whatwedolastboxbody centermobile">Site Engineer</p>
            {/* <button type="submit" class="hmfirstboxbuttonlast">LEARN MORE</button> */}

            </div>
            </div>

       



                        <Row/>




               
               
                
            </Row>




          

      
    </div>





    {/* <div className='hmfourthbox'>
    <div className=''>

            <Row>
                <div className='col-md-4'>
        <p className='hmcia fordesktoponly'>Current
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p>

        <p className='hmcia formobileonly'>Current
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p>
        <p  className="hmwwdp"></p>
        <p className='hmfourthboxinner hmfourthboxinner1 '>
        We are building long-term relationships with our clients, partnering with individuals and institutions to achieve long term financial growth.
        </p>
                    </div>


                    <div className='col-md-4 hciabox1'>
                  
                        <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}} src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Real estate</p>
                        <p  className='hmfourthboxinner'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

        

                    <div className='col-md-4 hciabox2'>
                    <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}}src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Credit Investment</p>
                        <p  className='hmfourthboxinner'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

               
               
                
            </Row>

            <Row className="ciasecondbox">
                <div className='col-md-4'>

                    </div>


                    <div className='col-md-4 hciabox2'>
                        <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}}src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Agriculture</p>
                        <p   className='hmfourthboxinner2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

            

                    <div className='col-md-4 hciabox1'>
                    <p className='ciaimagebox'><img src="images/homeicon.png"/> <span><img style={{float:"right", paddingTop:"14px"}}src="images/arrow_forward.png"/> </span></p>
                        <p className="hmciahead">Real estate</p>
                        <p   className='hmfourthboxinner2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus elementum lectus augue euismod faucibus.</p>
                    </div>

               
               
                
            </Row>
   
        </div>
    </div> */}

 



    {/* <div className='hmseventhbox'>
    <div className=''>
    <h1 className="hmwwd2 fordesktoponly">Creating a great <span style={{color:"#D80032"}}>experience for you<br/></span> begins with  a conversation.</h1>
    <h1 className="hmwwd2 formobileonly">Creating a great <span style={{color:"#D80032"}}>experience for you </span> begins with a conversation.</h1>

            <hr class="hpwwdhr3"/>
       
            <Row className="innerboxseven">
        

                <div className='col-md-5'>
                    <h1 className='hmwwd2head'>Contact Info</h1>
                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                    </p>

<div className='innersesventhbody'>
                    <Row>
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/phone.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <h1 className='innerboxsevendescriptionicon'>Phone number</h1>
                            <p className='innerboxsevendescriptiontext'>+234 123 456 7890, +234 123 456 7890</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/mail.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Email address</p>
                            <p className='innerboxsevendescriptiontext'>samplemail@rich-oaks.com<br/> anothersamplemail2@rich-oaks.com</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/office.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Address</p>
                            <p className='innerboxsevendescriptiontext'>Plot 1072 Grand Pela Hotel Street, Durumi Area 1. Abuja</p>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-md-2">
                            <img src="images/icons/clock.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Office Hours</p>
                            <p className='innerboxsevendescriptiontext'>Mondays - Fridays: 9am - 5pm</p>
                        </div>
                    </Row>
                    </div>

                </div>
<hr className="hrmobile formobileonly"/>
                    <div className='col-md-1'></div>

                    <div className='col-md-5'>
                    <h1 className='hmwwd2head hmwwd2headmobile'>You can reach out to us</h1>

                    <p className='innerboxsevendescription'>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu leo cras in blandit mauris. Sociis dignissim luctus arcu lectus justo, vitae laoreet.
                                          </p>

                                          <form className='hmformmobile'>
  <div class="form-group">
    <label className='hmlabel' for="">Full Name</label>
    <input type="email" class="form-control form-control-lg hminput" id=""placeholder="Enter email"/>
  </div>


  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Email Address</label>
    <input type="password" class="form-control form-control-lg hminput" id="" placeholder="Password"/>
  </div>

  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Message</label>
    <textarea class="form-control hminput" id="" rows="6"></textarea>
  </div>

  <button type="submit" class="hmfirstboxbutton">SEND YOUR MESSAGE</button>
</form>
                  
                    </div>

            
                  
                 
            </Row>
        </div>
    </div> */}

 

<br/>
<br/>


    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {People as default}